const l = `<svg width="56" height="56" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
        <path d="M0 0h56v56H0z" />
        <path
            d="M39.782 28.84a2.12 2.12 0 00-.19-.893 2.614 2.614 0 00-.545-.767L18.978 7.654C18.522 7.218 17.965 7 17.306 7c-.422 0-.811.1-1.166.302a2.229 2.229 0 00-.836.818A2.26 2.26 0 0015 9.29c0 .62.22 1.166.659 1.635L34.106 28.84 15.659 46.756c-.44.47-.659 1.015-.659 1.635 0 .436.101.826.304 1.17.203.344.482.617.836.818.355.201.744.302 1.166.302.659 0 1.216-.226 1.672-.68l20.07-19.5c.236-.235.417-.49.544-.767a2.12 2.12 0 00.19-.894z"
            fill="currentColor" fill-rule="nonzero" />
    </g>
</svg>`;
export {
  l as default
};
//# sourceMappingURL=arrow-right.es.DQ0y3q2u.js.map
